export default __webpack_public_path__ + "static/media/65.bcfdf0bb.gif";